module.exports = __webpack_public_path__ + "img/zhangfeihang.ec7b6d43.jpg";